<template lang="html">
  <div>
    <Card :collapse='1' :show='1' >
      <template slot="show-title">Create a new user</template>
      <form @submit.prevent='submitUserCreate'>
        <FormField :inline='1' :value='newUserForm.name' placeholder="Name" labelText='Name' :onUpdate='e => { newUserForm.name = e }' />
        <FormField :inline='1' :value='newUserForm.email' placeholder="Email" labelText='Email' :onUpdate='e => { newUserForm.email = e }' />
        <FormField :inline='1' type="password" :value='newUserForm.password' placeholder="Password" labelText='Password' :onUpdate='e => { newUserForm.password = e }' />

        <button type="submit" class="btn btn-primary cr-245">Create User</button>
      </form>
    </Card>
    <Spinner v-if='!users' />
    <Select v-else class='select-user' :options='users' label="displayTitle" v-model='item' />

    <Spinner v-show='isLoading' />
    <div v-if='selectedUser'>
      <Card>
        <span slot="show-title">General Information</span>
        <span slot="card-title" class="card-title-spaced">
          General Information
        </span>
        <UserForm :editUser='selectedUser' :display='{roles: 0}' :onSubmit='editUser' :performSubmit='performSubmit' />
      </Card>
      <!-- <Card>
        <span slot="show-title">Assigned Offers</span>
        <span slot="card-title" class="card-title-spaced">
          Assigned Offers
          <div>
            <button type="button" class="btn btn-primary">Reset</button>
            <button type="button" class="btn btn-success">Save</button>
          </div>
        </span>
        <MoveLists :list1='selectedUser.offers.pool' :list2='selectedUser.offers.associated' />
      </Card>
    -->
      <!-- <Card>
        <span slot="show-title">Dashboard Users</span>
        <span slot="card-title" class="card-title-spaced">
          Dashboard Users
          <div>
            <button type="button" class="btn btn-primary">Reset</button>
            <button type="button" @click='onSubmit' class="btn btn-success">Save</button>
          </div>
        </span>
        <MoveLists />
      </Card> -->
    </div>
  </div>
</template>

<script>
import UserForm from '@/components/shared/UserForm'

export default {
  components: {UserForm},
  created() {
    this.$http.get(this.resources.Admin.users)
      .then(r => r.json())
      .then(users => {
        users.forEach(u => u.displayTitle = u.name + `(${u.email})`)
        this.users = users
        // this.selectedUser = users.find(v => v.id == 27) // dev
      })
    return
    this.$http.post('app/modules/users/api/advids')
      .then(r => r.json())
      .then(r => r.data)
      .then(data => {
        this.advIds = data
      })
  },
  data () {
    return {
      performSubmit: 0,
      users: null,
      isLoading: false,
      item: null,
      selectedUser: null,
      newUserForm: {
        name: null,
        email: null,
        password: null
      }
    }
  },
  computed: {
    usersList() {
      let obj = {}
      this.users.forEach(e => {
        obj[e.id] = `${e.name} (${e.email})`
         })
      return obj
    }
  },
  watch: {
    item(val) {
      this.selectedUser = val
    }
  },
  methods: {
    submitUserCreate() {
      let form = Object.assign({}, this.newUserForm)
      this.$http.post(this.resources.Admin.users, form)
        .then(r => r.json())
        .then(user => {
          this.newUserForm = {
            name: null, email: null, password: null
          }
          user.displayTitle = user.name + `(${user.email})`

          this.users && this.users.push(user)
        })
    },
    onSubmit() {

    },
    editUser(form) {
      this.$http.put(this.resources.Admin.editUser(form.id), form)
        .then(r => {
          let editedUser = this.users.find(v => v.id === form.id)
          Object.assign(editedUser, form)
          this.notifySuccess("User has been edited")
        })
        .catch(err => {
          this.notifyError("Error has occured")
        })
    }
  }
}

</script>

<style lang="css" scoped>
.select-user {
  margin-bottom: 20px;
}
.card-title-spaced {
  display: flex;
  justify-content: space-between;
}
.cr-245 {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/EditUser.admin.vue